import { ChildrenStoreData } from "src/shared/types/src";
import { getAxiosInstance } from "../api";

export const fetchPlanningSheet = async ({ child, date }: { child: ChildrenStoreData, date: string }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();

    return retryAxios.get(`/child/${child.childId}/home-learning/planning-sheet?date=${date}`).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
};

export const fetchResources = async ({ child }: { child: ChildrenStoreData }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();

    return retryAxios.get(`/child/${child.childId}/home-learning/documents`).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
};